import React from 'react'
import ArrowIcon from '../../assets/icons/arrow.svg'
import ArrowWhiteIcon from '../../assets/icons/arrowWhite.svg'

import './IndexPage.css'

const buildVisiblePages = (indexPages, cantPages, pageActual) => {
  if (cantPages <= 5) {
    return indexPages
  }

  // Siempre se muestran 1, 2, las últimas 2 y la página actual (para que
  // siempre haya un indicador de en qué página estamos), con "..." entre
  // los tramos que no son consecutivos.
  const pagesSet = new Set([1, 2, cantPages - 1, cantPages, pageActual])
  const sorted = [...pagesSet]
    .filter(page => page >= 1 && page <= cantPages)
    .sort((a, b) => a - b)

  const visiblePages = []
  sorted.forEach((page, i) => {
    if (i > 0 && page - sorted[i - 1] > 1) {
      visiblePages.push('...')
    }
    visiblePages.push(page)
  })
  return visiblePages
}

const IndexPage = ({ pageActual, setPageActual, indexPages, cantPages }) => {
  const visiblePages = buildVisiblePages(indexPages, cantPages, pageActual)

  return (
    <div className='index-pages'>
      {pageActual !== 1 && (
        <button
          onClick={() => setPageActual(pageActual - 1)}
          disabled={pageActual === 1}
        >
          <img src={ArrowWhiteIcon} alt='' />
          <img src={ArrowIcon} alt='' />
        </button>
      )}
      {visiblePages.map((index, key) =>
        index === '...' ? (
          <div key={`ellipsis-${key}`} className='index-page ellipsis'>
            <p>...</p>
          </div>
        ) : (
          <div
            key={index}
            onClick={() => setPageActual(index)}
            className={`index-page ${pageActual === index ? 'selected' : ''}`}
          >
            <p>{index}</p>
          </div>
        )
      )}
      {pageActual !== cantPages && (
        <button
          disabled={pageActual === cantPages}
          onClick={() => setPageActual(pageActual + 1)}
        >
          <img src={ArrowWhiteIcon} alt='' />
          <img src={ArrowIcon} alt='' />
        </button>
      )}
    </div>
  )
}

export default IndexPage
